import { gql } from "@apollo/client";

const CREATE_TRIAL_PACKAGE = gql`
  mutation CreateTrialPackage($input: CreateTrialPackageInput!) {
    createTrialPackage(input: $input) {
      trialPackage {
        status
        startDate
        endDate
        paymentMethodId
        packageDuration
        priceId
        credits
      }
    }
  }
`;

export default CREATE_TRIAL_PACKAGE;
